const truncateIfLong2 = (str, limit) => {
    if (str?.length > limit) {
        return str?.slice(0, limit) + '...';
    }
    return str;
}
export default truncateIfLong2;